export default "__VITE_ASSET__e53d95e7__"